import { render, staticRenderFns } from "./ModelTreeVulkan.vue?vue&type=template&id=90786b2c&scoped=true"
import script from "./ModelTreeVulkan.vue?vue&type=script&lang=js"
export * from "./ModelTreeVulkan.vue?vue&type=script&lang=js"
import style0 from "./ModelTreeVulkan.vue?vue&type=style&index=0&id=90786b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90786b2c",
  null
  
)

export default component.exports